import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { bankAccountService } from "../services/bankAccount.service";

export const fetchBankAccounts = createAsyncThunk("bankAccount/fetchAll", async (_, thunkAPI) => {
  try {
    return await bankAccountService.getBankAccounts();
  } catch (err) {
    return thunkAPI.rejectWithValue("Failed to fetch bank accounts");
  }
});

export const fetchBankAccountById = createAsyncThunk("bankAccount/fetchById", async (id, thunkAPI) => {
  try {
    return await bankAccountService.getBankAccountById(id);
  } catch (err) {
    return thunkAPI.rejectWithValue("Failed to fetch bank account");
  }
});

export const addBankAccount = createAsyncThunk("bankAccount/add", async (bankAccount, thunkAPI) => {
  try {
    return await bankAccountService.createBankAccount(bankAccount);
  } catch (err) {
    return thunkAPI.rejectWithValue("Failed to create bank account");
  }
});

export const editBankAccount = createAsyncThunk("bankAccount/edit", async ({ id, bankAccount }, thunkAPI) => {
  try {
    return await bankAccountService.updateBankAccount(id, bankAccount);
  } catch (err) {
    return thunkAPI.rejectWithValue("Failed to update bank account");
  }
});

export const removeBankAccount = createAsyncThunk("bankAccount/remove", async (id, thunkAPI) => {
  try {
    await bankAccountService.deleteBankAccount(id);
    return id;
  } catch (err) {
    return thunkAPI.rejectWithValue("Failed to delete bank account");
  }
});

const bankAccountSlice = createSlice({
  name: "bankAccount",
  initialState: { bankAccounts: [], totalCount: 0, bankAccount: null, loading: false, error: null, showModal: false, showDeleteModal: false },
  reducers: {
    openModal: (state) => {
      state.showModal = true;
    },
    closeModal: (state) => {
      state.showModal = false;
    },
    openDeleteModal: (state) => {
      state.showDeleteModal = true;
    },
    closeDeleteModal: (state) => {
      state.showDeleteModal = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBankAccounts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBankAccounts.fulfilled, (state, action) => {
        state.loading = false;
        state.bankAccounts = action.payload;
      })
      .addCase(fetchBankAccounts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchBankAccountById.fulfilled, (state, action) => {
        state.bankAccount = action.payload;
      })
      .addCase(addBankAccount.pending, (state) => {
        state.loading = true;
      })
      .addCase(addBankAccount.fulfilled, (state, action) => {
        state.bankAccounts.push(action.payload);
        state.loading = false;
        state.showModal = false;
      })
      .addCase(editBankAccount.pending, (state) => {
        state.loading = true;
      })
      .addCase(editBankAccount.fulfilled, (state, action) => {
        state.bankAccounts = state.bankAccounts.map((ba) =>
          ba.accountId === action.payload.accountId ? action.payload : ba
        );
        state.loading = false;
        state.showModal = false;
      })
      .addCase(removeBankAccount.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeBankAccount.fulfilled, (state, action) => {
        state.bankAccounts = state.bankAccounts.filter((ba) => ba.accountId !== action.payload);
        state.loading = false;
        state.showDeleteModal = false;
      });
  },
});

export const { openModal, closeModal, openDeleteModal, closeDeleteModal } = bankAccountSlice.actions;
export default bankAccountSlice.reducer;